// SMS Components

import PageNotFound from './components/common/404-page.vue';
import EmailAutomationList from './components/email-automation-lists/views/email-automation-lists.vue';

// Events Components
import EventIndex from './components/events/index.vue';
import EventRecordsIndex from './components/events/event-records/index.vue';
import EventIntegrations from './components/events/event-records/integrations.vue';
import EventRecords from './components/events/event-records/event-records.vue';
import EventSingleRecord from './components/events/event-records/single-event-record.vue';
import EventCreate from './components/events/event-steps/index.vue';
import EventCreateBasicInfo from './components/events/event-steps/basic-info.vue';
import EventCreateStaticFormBuilder from './components/events/static-web-forms/static-form-builder.vue';
import EventCreateDynamicFormBuilder from './components/events/dynamic-web-forms/dynamic-form-builder/dynamic-form-builder.vue';
import EventCreateLogic from './components/events/event-steps/logic.vue';
import EventCreateMessgaes from './components/events/event-steps/messages.vue';
import EventCreateAutomations from './components/events/event-steps/automations.vue';

const routes = [
  { path: '/404', name: 'page-not-found', component: PageNotFound },
  { path: '*', redirect: '/404' },
  { path: '/', redirect: 'email-automation-lists' },
  { path: '/email-automation-lists', component: EmailAutomationList },
];

const EventsRoutes = [
  { path: '/404', name: 'page-not-found', component: PageNotFound },
  { path: '*', redirect: '/404' },
  {
    path: '/', component: EventIndex, name: 'events-index', props: { routeTitle: 'Events', routeHeading: 'Create and manage your events' },
  },
  {
    path: '/:eventId',
    name: 'event-records-index',
    component: EventRecordsIndex,
    children: [
      {
        path: 'integrations',
        name: 'event-integrations',
        component: EventIntegrations,
      },
      {
        path: 'records',
        name: 'event-records',
        component: EventRecords,
      },
      {
        path: 'records/:recordId',
        name: 'single-event-record',
        component: EventSingleRecord,
      },
    ],
  },
  // STATIC WEBFORMS ROUTES
  {
    path: '/create-event/static',
    component: EventCreate,
    props: { routeTitle: 'Create Event', routeHeading: 'Create and manage your Events' },
    children: [
      {
        path: 'basic-info/:id?',
        name: 'basic-info',
        component: EventCreateBasicInfo,
      },
      {
        path: 'form-builder/:id',
        name: 'form-builder',
        component: EventCreateStaticFormBuilder,
      },
      {
        path: 'messages/:id',
        name: 'messages',
        component: EventCreateMessgaes,
      },
      {
        path: 'automations/:id',
        name: 'automations',
        component: EventCreateAutomations,
      },
    ],
  },
  // DYNAMIC WEBFORMS ROUTES
  {
    path: '/create-event/dynamic',
    component: EventCreate,
    props: { routeTitle: 'Create Event', routeHeading: 'Create and manage your Events' },
    children: [
      {
        path: 'basic-info/:id?',
        name: 'basic-info-dynamic-form',
        component: EventCreateBasicInfo,
      },
      {
        path: 'form-builder/:id',
        name: 'form-builder-dynamic-form',
        component: EventCreateDynamicFormBuilder,
      },
      {
        path: 'logic/:id',
        name: 'logic-dynamic-form',
        component: EventCreateLogic,
      },
      {
        path: 'messages/:id',
        name: 'messages-dynamic-form',
        component: EventCreateMessgaes,
      },
      {
        path: 'automations/:id',
        name: 'automations-dynamic-form',
        component: EventCreateAutomations,
      },
    ],
  },
];

export { routes, EventsRoutes };
